import './VtxAlert.scss';
import * as React from 'react';
import { FunctionComponent } from 'react';
import { Alert, AlertProps } from 'antd';
import classNames from 'classnames';
import { IAutomatable, preventDataAutomationOverriding } from '../../helpers/IAutomatable';
import { VtxIcon, VtxIconProps } from '../icon/VtxIcon';
export const { ErrorBoundary } = Alert;

export interface VtxAlertProps extends Omit<AlertProps, 'icon'>, IAutomatable {
    icon?: VtxIconProps;
}

export const VtxAlert: FunctionComponent<VtxAlertProps> = React.memo((props: VtxAlertProps) => {
    const automationClass = 'vtx-alert';
    const { className, message, icon, ...otherProps } = preventDataAutomationOverriding(props);
    const listOfClassNames = classNames(automationClass, className);

    return (
        <Alert
            className={listOfClassNames}
            data-automation-class={automationClass}
            message={message}
            icon={icon ? <VtxIcon {...icon} /> : undefined}
            {...otherProps}
        />
    );
});
